import { getWsBasePath } from "../utils";
export const MAIL_ACCOUNT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/MAIL/ACCOUNT`;
export const MAIL_CONTACT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/MAIL/CONTACT`;
export const MAIL_CHAT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/MAIL/CHAT`;
